var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsIn, IsInt, Max, Min, ValidateIf, ValidateNested } from 'class-validator';
import { CANCELLATION_FIXED_AMOUNT_CENTS_MAX, CANCELLATION_FIXED_AMOUNT_CENTS_MIN, CANCELLATION_GRACE_HOURS_MAX, CANCELLATION_GRACE_HOURS_MIN, CANCELLATION_PERCENT_MAX, CANCELLATION_PERCENT_MIN, } from '../../treatment-plan/value-objects/cancellation-fee-policy.types.js';
export class CancellationFeeAmountRuleDto {
    kind;
    /** Only meaningful when `kind = 'fixed'`. */
    fixedAmountCents;
    /** Only meaningful when `kind = 'percentage'`. */
    percent;
}
__decorate([
    IsIn(['fullRate', 'fixed', 'percentage']),
    __metadata("design:type", String)
], CancellationFeeAmountRuleDto.prototype, "kind", void 0);
__decorate([
    ValidateIf((o) => o.kind === 'fixed'),
    IsInt(),
    Min(CANCELLATION_FIXED_AMOUNT_CENTS_MIN),
    Max(CANCELLATION_FIXED_AMOUNT_CENTS_MAX),
    __metadata("design:type", Number)
], CancellationFeeAmountRuleDto.prototype, "fixedAmountCents", void 0);
__decorate([
    ValidateIf((o) => o.kind === 'percentage'),
    IsInt(),
    Min(CANCELLATION_PERCENT_MIN),
    Max(CANCELLATION_PERCENT_MAX),
    __metadata("design:type", Number)
], CancellationFeeAmountRuleDto.prototype, "percent", void 0);
/**
 * Body for
 * `PATCH /office-location-billing-details/:officeLocationId/cancellation-fee-policy`.
 *
 * `policy = null` means "the practice levies no cancellation fee". Any other
 * value is a configured policy that snapshots onto new
 * `AgreementData` rows at plan creation; existing plans are not retroactively
 * updated.
 */
export class UpdateCancellationFeePolicyDto {
    policy;
}
__decorate([
    ValidateIf((_, value) => value !== null),
    ValidateNested(),
    Type(() => CancellationFeePolicyBodyDto),
    __metadata("design:type", Object)
], UpdateCancellationFeePolicyDto.prototype, "policy", void 0);
export class CancellationFeePolicyBodyDto {
    cancellationGraceHours;
    amount;
}
__decorate([
    IsInt(),
    Min(CANCELLATION_GRACE_HOURS_MIN),
    Max(CANCELLATION_GRACE_HOURS_MAX),
    __metadata("design:type", Number)
], CancellationFeePolicyBodyDto.prototype, "cancellationGraceHours", void 0);
__decorate([
    ValidateNested(),
    Type(() => CancellationFeeAmountRuleDto),
    __metadata("design:type", CancellationFeeAmountRuleDto)
], CancellationFeePolicyBodyDto.prototype, "amount", void 0);
//# sourceMappingURL=update-cancellation-fee-policy.dto.js.map